var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "button",
            { staticClass: "btn btn-secondary", on: { click: _vm.refresh } },
            [_c("i", { staticClass: "fas fa-sync-alt fa-fw" })]
          ),
          _vm._v(" "),
          _vm.canCreate
            ? _c(
                "button",
                { staticClass: "btn btn-purple", on: { click: _vm.onCreate } },
                [_c("i", { staticClass: "far fa-file fa-fw" })]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "align-self-end d-flex" },
          [
            _c(
              "el-select",
              {
                staticClass: "w-150 mr-2 mb-2",
                attrs: { placeholder: "All statuses", clearable: "" },
                model: {
                  value: _vm.statusFilter,
                  callback: function ($$v) {
                    _vm.statusFilter = $$v
                  },
                  expression: "statusFilter",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: "Pending", value: "pending" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "Approved", value: "approved" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "Rejected", value: "rejected" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("input-debounced", {
              staticClass: "search-bar w-300 mb-2",
              attrs: {
                clearable: true,
                autofocus: true,
                placeholder: "Search",
              },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("base-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isRefreshing,
            expression: "isRefreshing",
          },
        ],
        ref: "baseTable",
        attrs: {
          "base-url": _vm.urlWithFilters,
          "current-page": _vm.currentPage,
          "element-loading-spinner": "el-icon-loading",
        },
        on: { "load-success": _vm.onLoadSuccess, refresh: _vm.onRefresh },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "el-table",
                  {
                    staticClass: "w-100",
                    attrs: { data: _vm.items, stripe: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "model.id", label: "Id", width: "80" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.user.email",
                        label: "Author",
                        "min-width": "120",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.content",
                        label: "Content",
                        "min-width": "120",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Status", width: "110" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            row: {
                              model: { status },
                            },
                          }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.statusType(status),
                                    size: "small",
                                  },
                                },
                                [_vm._v(_vm._s(status))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Brands", "min-width": "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            row: {
                              model: { brands },
                            },
                          }) {
                            return [
                              _c("brand-column", { attrs: { brands: brands } }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Tags", "min-width": "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            row: {
                              model: { tags },
                            },
                          }) {
                            return [
                              _c("tags-column", { attrs: { tags: tags } }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.created_at",
                        label: "Created At",
                        width: "124",
                        formatter: _vm.formatDate,
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.updated_at",
                        label: "Updated At",
                        width: "124",
                        formatter: _vm.formatDate,
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Actions", width: "160" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("actions-column", {
                                attrs: { row: row },
                                on: {
                                  edit: _vm.onEdit,
                                  delete: _vm.onDelete,
                                  approve: _vm.onApprove,
                                  reject: _vm.onReject,
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "text-right",
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }